export const REACHED_MAX_USERS = "REACHED_MAX_USERS"

export default {
  REACHED_MAX_USERS,
}



// WEBPACK FOOTER //
// ./src/constants/error.js